import type { ThemeOptions } from "@mui/material";

import { createMaterialThemeOptions } from "../createMaterialThemeOptions";
import type { DesignerTheme } from "../DesignerTheme";
import { darkScheme } from "./colorScheme";
import { themeCore } from "./themeCore";

const darkThemeOptions: Omit<DesignerTheme<"dark">, "materialThemeOptions"> = {
  name: "dark" as const,
  type: "dark",
  ...themeCore,

  global: `
    :root {
      color-scheme: dark;
    }
    .icon-color-1 {
      fill: #76CBEE;
    }
    .icon-color-2 {
      fill: #C9E9F4;
    }
    .icon-color-3 {
      fill: #ACDEF3;
    }
    .icon-color-4 {
      fill: #fff;
    }
  `,

  boxShadow: {
    normal: "0px 1px 2px rgba(0, 0, 0, 0.15)",
    hover: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    selected: "0px 5px 10px rgba(0, 0, 0, 0.15)",
    interacting: "0px 8px 16px rgba(0, 0, 0, 0.15)",
    below: `0px 10px 10px -4px rgba(0, 0, 0, 0.15)`,
  },

  moduleMap: {
    background: darkScheme.surfaceBack_1,
    backgroundSecondary: "#353535",
    connectorColor: darkScheme.neutral,
  },

  colorGroup: [
    "#ffa726",
    "#ab47bc",
    "#66bb6a",
    "#5c6bc0",
    "#ef5350",
    "#26a69a",
    "#29b6f6",
    "#ffca28",
    "#ec407a",
    "#9ccc65",
    "#7e57c2",
    "#26c6da",
    "#d4e157",
    "#42a5f5",
  ],

  ...darkScheme,
};

const darkMaterialThemeOptions = (theme: Omit<DesignerTheme<"dark">, "materialThemeOptions">): ThemeOptions => {
  const materialThemeOptions = createMaterialThemeOptions(theme);
  return {
    ...materialThemeOptions,
    palette: {
      ...materialThemeOptions.palette,
      mode: "dark",
      background: {
        paper: theme.surface,
        default: theme.surface,
      },
      text: {
        primary: theme.generalTextIcon,
        secondary: theme.generalTextIcon,
        disabled: "rgba(255, 255, 255, 0.38)",
      },
    },
    components: {
      ...materialThemeOptions.components,
      MuiPaper: {
        ...materialThemeOptions.components?.MuiPaper,
        defaultProps: {
          style: {
            // @ts-ignore
            "--Paper-overlay": theme.surface,
          },
        },
      },
    },
  };
};

export const DarkTheme: DesignerTheme<"dark"> = {
  ...darkThemeOptions,
  materialThemeOptions: darkMaterialThemeOptions(darkThemeOptions),
} as const;
